import { Vector3 } from "three";
import { RaycasterHelper } from "./raycaster";

export function findNearestCollision(origin: Vector3, dest: Vector3, scene: THREE.Scene, camera: THREE.Camera): THREE.Vector3 | null {
    const raycaster = new RaycasterHelper(camera, scene);
    raycaster.far = 100;

    const intersections = raycaster.getIntersectObjects(
        origin,
        dest,
        undefined,
        100
    );
    if (intersections.length > 0) {
        return intersections[0].point.clone();
    }
    return null;
}